import {
  SUBMIT_BAZAAR_ENQUIRY_REQUEST,
  SUBMIT_BAZAAR_ENQUIRY_SUCCESS,
  SUBMIT_BAZAAR_ENQUIRY_FAILURE,
  SUBMIT_BAZAAR_ENQUIRY_RESET,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  error: false,
  alreadyCaptured: false,
  success: false,
  message: "",
}

const submitBazaarEnquiryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_BAZAAR_ENQUIRY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        alreadyCaptured: false,
        success: false,
        message: "",
      }

    case SUBMIT_BAZAAR_ENQUIRY_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        alreadyCaptured: false,
        message: action.payload.message || "Walk-in captured successfully",
      }

    case SUBMIT_BAZAAR_ENQUIRY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        alreadyCaptured: !!action.payload.already_captured,
        success: false,
        message: "",
      }

    case SUBMIT_BAZAAR_ENQUIRY_RESET:
      return { ...initialState }

    default:
      return state
  }
}

export default submitBazaarEnquiryReducer
